import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import { useLocation } from 'react-router-dom';
import Footnote from '../components/Sidebar/Footnote/Footnote';
import ScrollToTop from '../components/ScrollToTop';
import './MainLayout.css';

const AuthLayout = () => {
  const location = useLocation();
  let marginBottom;
  if (location.pathname.includes('role')) {
    marginBottom = '80px';
  } else {
    marginBottom = '0';
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div className="page-wrapper">
        <div
          className="content-wrapper"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '80px',
            marginBottom: marginBottom,
          }}
        >
          <Outlet />
        </div>
        <footer className="footer-container">
          <Footnote />
        </footer>
      </div>
    </>
  );
};
export default AuthLayout;
